var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        "position-x": _vm.positionX,
        "position-y": _vm.positionY,
        absolute: "",
        "offset-y": "",
        "close-on-content-click": false,
        "close-on-click": false,
        "z-index": 15,
        "data-testid": "pie-chart-popup",
      },
      model: {
        value: _vm.isOpen,
        callback: function ($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _vm.trap
        ? _c(
            "v-card",
            { staticClass: "pie-chart-popup-card", attrs: { elevation: "4" } },
            [
              _c("v-card-title", { staticClass: "py-2 text-subtitle-1" }, [
                _vm._v("\n      " + _vm._s(_vm.trap.trapNo) + "\n    "),
              ]),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c("v-card-text", { staticClass: "pa-3" }, [
                _c("div", { staticClass: "d-flex align-center" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "pie-chart-svg",
                      attrs: {
                        width: _vm.chartSize,
                        height: _vm.chartSize,
                        viewBox: "0 0 " + _vm.chartSize + " " + _vm.chartSize,
                      },
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: {
                            transform:
                              "translate(" +
                              _vm.chartSize / 2 +
                              ", " +
                              _vm.chartSize / 2 +
                              ")",
                          },
                        },
                        [
                          _vm._l(_vm.pieSegments, function (segment) {
                            return _c("path", {
                              key: segment.type,
                              attrs: {
                                d: segment.path,
                                fill: segment.color,
                                "data-testid": "pie-segment",
                              },
                            })
                          }),
                          _vm._v(" "),
                          _c("line", {
                            attrs: {
                              x1: "0",
                              y1: "0",
                              x2: 0,
                              y2: -_vm.chartRadius,
                              stroke: "white",
                              "stroke-width": "2",
                            },
                          }),
                          _vm._v(" "),
                          _c("line", {
                            attrs: {
                              x1: "0",
                              y1: "0",
                              x2: _vm.chartRadius,
                              y2: 0,
                              stroke: "white",
                              "stroke-width": "2",
                            },
                          }),
                          _vm._v(" "),
                          _c("line", {
                            attrs: {
                              x1: "0",
                              y1: "0",
                              x2: 0,
                              y2: _vm.chartRadius,
                              stroke: "white",
                              "stroke-width": "2",
                            },
                          }),
                          _vm._v(" "),
                          _c("line", {
                            attrs: {
                              x1: "0",
                              y1: "0",
                              x2: -_vm.chartRadius,
                              y2: 0,
                              stroke: "white",
                              "stroke-width": "2",
                            },
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "legend-section ml-3" },
                    _vm._l(_vm.legendItems, function (item) {
                      return _c(
                        "div",
                        {
                          key: item.type,
                          staticClass: "legend-item d-flex align-center mb-1",
                        },
                        [
                          _c("span", {
                            staticClass: "legend-color mr-2",
                            style: { backgroundColor: item.color },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "legend-label" }, [
                            _vm._v(_vm._s(item.label) + ":"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "legend-count ml-1 font-weight-medium",
                            },
                            [_vm._v(_vm._s(item.countDisplay))]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }